import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = {
  key: 1,
  class: "page-container card col-md-8"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-fw pi-calendar" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "RPK", -1)
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = { class: "d-flex justify-content-end" }
const _hoisted_10 = {
  key: 1,
  class: "row"
}
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "error-no-record mt-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-12 d-flex" }
const _hoisted_18 = {
  key: 0,
  class: "col-md-12 mt-3"
}
const _hoisted_19 = { class: "d-flex justify-content-end" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Click “No” to clear the Global Filter and view all companies."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Click “Yes” to proceed with Global Filter. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_TheSheetsDialog = _resolveComponent("TheSheetsDialog")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_TheLoading = _resolveComponent("TheLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_TheHeader, { key: _ctx.filteredApprovalList })),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.isPageLoading)
              ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isPageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ThePageHeader, {
                    renderSearch: true,
                    isSearching: _ctx.isSearching,
                    onSearch: _ctx.filterByCompanyName
                  }, null, 8, ["isSearching", "onSearch"]),
                  (!_ctx.pageError)
                    ? (_openBlock(), _createBlock(_component_TabView, {
                        key: 0,
                        class: "p-1",
                        activeIndex: _ctx.activeIndex,
                        "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeIndex) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_TabPanel, null, {
                            header: _withCtx(() => [
                              _hoisted_6,
                              _hoisted_7,
                              (_ctx.approvalCount != null && _ctx.approvalCount > 0)
                                ? (_openBlock(), _createBlock(_component_Badge, {
                                    key: 0,
                                    class: "ms-1 approval-badge",
                                    value: _ctx.approvalCount,
                                    severity: "danger"
                                  }, null, 8, ["value"]))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              (_ctx.filteredApprovalList != null && _ctx.filteredApprovalList.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredApprovalList, (approval, companyIndex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "col-md-12",
                                        key: companyIndex
                                      }, [
                                        _createVNode(_component_DataTable, {
                                          value: approval.companyReports,
                                          sortField: "companyName",
                                          sortOrder: -1,
                                          tableStyle: "min-width: 50rem"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Column, {
                                              field: "company.name",
                                              header: "Company Name",
                                              sortable: "",
                                              style: {"min-width":"15rem"}
                                            }, {
                                              body: _withCtx((slotProps) => [
                                                _createElementVNode("span", null, _toDisplayString(slotProps.data.company.name + ' (' + slotProps.data.company.code + ')'), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_Column, {
                                              field: "fileId",
                                              header: "File ID",
                                              sortable: "",
                                              style: {"min-width":"14rem"}
                                            }),
                                            _createVNode(_component_Column, {
                                              field: "submissionDate",
                                              header: "Submitted on",
                                              sortable: true,
                                              style: {"min-width":"12rem"}
                                            }, {
                                              body: _withCtx((slotProps) => [
                                                _createElementVNode("span", null, _toDisplayString(slotProps.data.submissionDate), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_Column, {
                                              field: "identifier",
                                              sortable: false,
                                              style: {"min-width":"12rem"}
                                            }, {
                                              body: _withCtx((slotProps) => [
                                                _createElementVNode("div", _hoisted_9, [
                                                  _createVNode(_component_Button, {
                                                    class: "p-button-sm p-button-warning me-4",
                                                    onClick: ($event: any) => (_ctx.view(slotProps.data)),
                                                    label: "View"
                                                  }, null, 8, ["onClick"])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["value"])
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                      _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_component_FontAwesomeIcon, {
                                          icon: ['fas', 'image'],
                                          size: "2x"
                                        }),
                                        _hoisted_13
                                      ])
                                    ])
                                  ]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["activeIndex"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_TheSheetsDialog, {
                    isFromApproval: true,
                    identifier: _ctx.sheetDialog.identifier,
                    name: _ctx.sheetDialog.companyName,
                    type: 'rpk',
                    balanceSheetDate: _ctx.sheetDialog.balanceSheetDate == null ? null : _ctx.formatToDate(_ctx.sheetDialog.balanceSheetDate),
                    currencyCode: _ctx.sheetDialog.currencyCode,
                    purpose: _ctx.sheetDialog.purpose,
                    id: _ctx.sheetDialog.id,
                    templateIndex: _ctx.sheetDialog.templateIndex,
                    status: _ctx.sheetDialog.status,
                    visible: _ctx.sheetDialog.visible,
                    loading: _ctx.sheetDialog.loading,
                    isUnsaved: _ctx.sheetDialog.isUnsaved,
                    isConsolidated: _ctx.sheetDialog.isConsolidated,
                    reportSheets: _ctx.sheetDialog.companyReportSheets,
                    onSave: _ctx.updateSheets,
                    onAutoSave: _ctx.updateSheetCached,
                    onDeleteCached: _ctx.deleteSheetCached,
                    onCancel: _ctx.closeSheetDialog
                  }, null, 8, ["identifier", "name", "balanceSheetDate", "currencyCode", "purpose", "id", "templateIndex", "status", "visible", "loading", "isUnsaved", "isConsolidated", "reportSheets", "onSave", "onAutoSave", "onDeleteCached", "onCancel"]),
                  (_ctx.pageError != '')
                    ? (_openBlock(), _createBlock(_component_ThePageError, {
                        key: 1,
                        onBackEvent: _ctx.back,
                        pageError: _ctx.pageError
                      }, null, 8, ["onBackEvent", "pageError"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowUnsavedConfirmation,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isShowUnsavedConfirmation) = $event)),
      header: "Recover Unsaved Changes",
      modal: "",
      style: { width: '40vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sheets(1, false, null))),
          text: ""
        }),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sheets(1, true, null))),
          hidden: _ctx.isViewer
        }, null, 8, ["hidden"])
      ]),
      default: _withCtx(() => [
        (_ctx.isViewer)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Any data entered by you (as a viewer) will not be saved or processed "))
          : (_openBlock(), _createElementBlock("p", _hoisted_15, " Unsaved changes detected and available to recovery. Would you like to recover these changes now? "))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.dialog.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialog.visible) = $event)),
      header: "Confirmation",
      modal: "",
      style: {width: '40vw'}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          (this.dialog.loading)
            ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            class: "p-button-text p-button-sm",
            label: "No",
            icon: "pi pi-times",
            onClick: _ctx.closeDialog
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "p-button-sm",
            label: "Yes",
            icon: "pi pi-check",
            onClick: _ctx.onConfirm,
            disabled: (_ctx.dialog.status == 'Rejected' && _ctx.dialog.remarks == '')
          }, null, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("i", {
                class: _normalizeClass(["mr-3 align-self-center", _ctx.dialog.icon != null && _ctx.dialog.icon != '' ? _ctx.dialog.icon : 'pi pi-exclamation-triangle']),
                style: {"font-size":"1.5rem"}
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(_ctx.dialog.message), 1)
            ]),
            (_ctx.dialog.withRemarks)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_Textarea, {
                    modelValue: _ctx.dialog.remarks,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialog.remarks) = $event)),
                    autoResize: true,
                    rows: "5",
                    cols: "30",
                    maxlength: "255",
                    placeholder: "Remarks",
                    autofocus: ""
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowGlobalFilterConfirmation,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isShowGlobalFilterConfirmation) = $event)),
      header: "Global Filter in use",
      modal: "",
      style: { width: '40vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          onClick: _ctx.proceedWithResetGlobalFilter,
          text: ""
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          onClick: _ctx.proceedGlobalFilterWarning
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_20
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}